import {
    FETCH_VARIANT,
    USER_LOADING,
    USER_FAIL,
    CREATE_VARIANT,
    FETCH_VARIANT_BY_ID,
} from '../constants/types';

const initialState = {
    loading: false,
    data: [],
    error: ''
}


export function variantData(state = initialState, action) {
    switch (action.type) {
        case FETCH_VARIANT:
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: ''
            }

        case FETCH_VARIANT_BY_ID:
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: ''
            }

        case CREATE_VARIANT:
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: ''
            }

        case USER_LOADING:
            return {
                ...state,
                data: [],
                loading: true,
                error: ''
            }

        case USER_FAIL:
            return {
                ...state,
                data: [],
                loading: false,
                error: action.payload
            }
        default:
            return state;
    }
}